//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        goTab (e) {
            this.$emit('goTab', e)
        }
    },
    props: {
        tabs: {
            type: Array
        },
        is_business: {
            type: Boolean,
            default: false
        }
    }
}
